<template>
  <Avatar
    :name="getContextNameLong(viewContext, creator)"
    :profile-url="creator.url"
    :image-url="creator.avatar_url"
    :clients="creator.clients"
    :variant="variant"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import Avatar from "components/UI/Avatar.vue"
import { getContextNameLong, ViewContext } from "concerns/useContextName"
import { GroupMember } from "suus-api"

export default defineComponent({
  name: "PostAvatar",
  methods: { getContextNameLong },
  components: { Avatar },
  props: {
    viewContext: Object as PropType<ViewContext>,
    creator: {
      type: Object as PropType<GroupMember>,
      required: true,
    },
    alwaysSmall: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variant(): "sm" | "md" {
      if (this.alwaysSmall) {
        return "sm"
      }
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "sm"
        case "sm":
          return "md"
        default:
          return "md"
      }
    },
  },
})
</script>
